import React, { useEffect, useRef } from "react";

const Header = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    const scrollStep = 0.5; // adjust the scrolling speed here
    let scrollAmount = 0;
    let scrollDirection = "right";
    let animationFrameId;

    const scroll = () => {
      if (scrollDirection === "right") {
        scrollAmount += scrollStep;
        container.scrollLeft = scrollAmount;

        // Change direction when reaching the end
        if (scrollAmount >= container.scrollWidth - container.clientWidth) {
          scrollDirection = "left";
        }
      } else {
        scrollAmount -= scrollStep;
        container.scrollLeft = scrollAmount;

        // Change direction when reaching the start
        if (scrollAmount <= 0) {
          scrollDirection = "right";
        }
      }

      animationFrameId = requestAnimationFrame(scroll);
    };

    const handleIntersection = (entries) => {
      const [entry] = entries;
      if (entry.isIntersecting) {
        // Start scrolling when the parent div is in view
        animationFrameId = requestAnimationFrame(scroll);
      } else {
        // Stop scrolling when the parent div is out of view
        cancelAnimationFrame(animationFrameId);
      }
    };

    const observer = new IntersectionObserver(handleIntersection, {
      root: null,
      rootMargin: "0px",
      threshold: 0,
    });

    observer.observe(container);

    // Clean up the observer and animation frame when the component unmounts
    return () => {
      observer.unobserve(container);
      cancelAnimationFrame(animationFrameId);
    };
  }, []);
  return (
    <div className="bg-grey-6 text-neutral-0 h-[50px] flex items-center justify-center sticky top-0 z-50 whitespace-nowrap flex-nowrap overflow-hidden">
      <div
        className="w-full flex justify-between items-center md:max-w-screen-xl h-full overflow-auto gap-4 no-scrollbar px-4 xl:px-0"
        ref={containerRef}
      >
        <div className="flex justify-between items-center h-full gap-[52px]">
          <a
            className="flex items-center gap-2 h-full"
            href="tel:+61404509680"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              width="16"
              height="16"
              aria-hidden="true"
            >
              <path d="M6.62 10.79a15.05 15.05 0 0 0 6.59 6.59l2.2-2.2a1 1 0 0 1 1.01-.24 11.36 11.36 0 0 0 3.56.57 1 1 0 0 1 1 1V20a1 1 0 0 1-1 1A17 17 0 0 1 3 4a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1 11.36 11.36 0 0 0 .57 3.56 1 1 0 0 1-.25 1.01l-2.2 2.22z" />
            </svg>
            <p className="text-sm">0404 509 680</p>
          </a>
          {/* <a
            className="flex items-center gap-2 h-full"
            target="_blank"
            rel="noopener noreferrer"
            href="https://maps.app.goo.gl/KW3gRPpLz3k5pjgQ8"
          >
            <span className="material-icons-round">room</span>
            <p className="text-sm">70 Hughes Crescent, Dandenong North, 3175</p>
          </a> */}
        </div>

        <div className="flex justify-end items-center h-full gap-8">
          {/* <a
            href="http://facebook.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="/assets/images/icons/facebook.png"
              className="w-6 h-6 min-w-6"
              alt=""
            />
          </a>
          <a
            href="http://instagram.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="/assets/images/icons/instagram.png"
              className="w-6 h-6 min-w-6"
              alt=""
            />
          </a>
          <a
            href="http://youtube.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="/assets/images/icons/youtube.png"
              className="w-6 h-6 min-w-6"
              alt=""
            />
          </a> */}
          <a
            className="flex items-center gap-2 h-full"
            target="_blank"
            rel="noopener noreferrer"
            href="https://maps.app.goo.gl/KW3gRPpLz3k5pjgQ8"
          >
            <span className="material-icons-round">room</span>
            <p className="text-sm">70 Hughes Crescent, Dandenong North, 3175</p>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Header;
